module.exports = __webpack_public_path__ + "img/enhorabuena.035f85c2.png";